import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import QueryString from 'query-string';
import SweetAlert from 'sweetalert-react';
import withSizes from 'react-sizes';
import { Link } from 'react-router-dom';

import * as Utils from '../../utils/utils';
import * as HtmlHelper from '../../utils/htmlHelper';
import * as ProductsActions from '../../actions/productsActions';
import ProductCard from '../../components/commons/cards/ProductCard';
import CollapsableItem from '../../components/commons/collapsable-item/CollapsableItem';
import Loader from '../../components/commons/loader/loader';
import SortFiltersModal from '../../components/commons/modals/SortFiltersModal';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import menuDepKeys from '../../utils/menuHelper';

class ProductListPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      products: [],
      isDescriptionPanelCollapsed: false,
      isSizePanelCollapsed: false,
      isLocationPanelCollapsed: false,
      limit: 20,
      skip: 0,
      isLoadMore: false,
      isParamsChanged: true,
      filters: DEFAULT_FILTERS,
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: [],
        filterby_vintage: [],
        filterby_range: []
      },
      selectedFilters: [],
      SortFiltersModalVisibility: false,
      filterSortAction: 'filter',
      showAlert: false,
      swalParams: {
        title: ""
      },
      scrollTop: 0,
      specialSale: undefined,
      value: { min: 0, max: 15 },
      maxValue: 0,
      minValue: 0,
      sortBy: 'name_asc',
      viewMode: 'grid',
      showSidebar: true
    }

    this.renderDescriptions = this.renderDescriptions.bind(this);
    this.renderSizes = this.renderSizes.bind(this);
    this.renderLocations = this.renderLocations.bind(this);
    this.renderVintage = this.renderVintage.bind(this);
    this.renderBreadcrumbs = this.renderBreadcrumbs.bind(this);
    this.renderCategoryTabs = this.renderCategoryTabs.bind(this);
    this.renderSubCategories = this.renderSubCategories.bind(this);
    this.renderAppliedFilters = this.renderAppliedFilters.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
    this.exploreProduct = this.exploreProduct.bind(this);
    this.renderLoadMoreButton = this.renderLoadMoreButton.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.selectFilter = this.selectFilter.bind(this);
    this.selectedFilterUnselect = this.selectedFilterUnselect.bind(this);
    this.updateRangeFilter = this.updateRangeFilter.bind(this);
    this.addValuesToFilter = this.addValuesToFilter.bind(this);
    this.rangeFilterUnselect = this.rangeFilterUnselect.bind(this);
    this.onChangeSortOption = this.onChangeSortOption.bind(this);
    this.openFilters = this.openFilters.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  componentDidMount() {

    const { location } = this.props;
    const pageState = Utils.toJS(this.props.pageState);
    let params = QueryString.parse(location.search);

    if (pageState && pageState.location && pageState.location.search == location.search) {
      this.setState(pageState, () => window.scrollTo(0, pageState.scrollTop));
    } else {
      this.loadProducts(params);
      this.loadFilters(params);
      window.scrollTo(0, 0);
    }

  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.filters &&  this.state.filters.filterby_range.items && this.state.filters.filterby_range.items[0]){
      if(this.state.filters.filterby_range.items[0] !== prevState.filters.filterby_range.items[0]){
        this.addValuesToFilter();
      } 
    }
  }

  componentWillReceiveProps(newProps) {

    const { location, match } = this.props;
    let params = QueryString.parse(newProps.location.search);
    if (location.search !== newProps.location.search || location.pathname !== newProps.location.pathname) {
      this.setState({
        isParamsChanged: true,
        selectedFilters: [],
        appliedFilters: {
          filterby_sizes: [],
          filterby_description: [],
          filterby_location: [],
          filterby_range: [],
          filterby_vintage: [],
        }
      }, () => {
        this.loadProducts(params)
        this.loadFilters(params)
      })
    } else {
      //this.setState({isParamsChanged: false})
    }

  }

  render() {
    const { match } = this.props;
    
    const heading = match && match.params
      ? match.params.special
      : null;

    const {products, showAlert, swalParams} = this.state;
    const {isMobile, loading} = this.props;

    const {
      isDescriptionPanelCollapsed,
      isSizePanelCollapsed,
      isLocationPanelCollapsed,
      isVintagePanintagePanelCollapsed,
      location,
      SortFiltersModalVisibility,
      filterSortAction,
      filters,
      appliedFilters,
      scrollTop,
      maxValue,
      minValue,
      sortBy,
      viewMode,
      showSidebar
    } = this.state;
    return (
      <div className="page product-list">
        <div className="container content-container">
          {this.renderBreadcrumbs(heading)}
          <div className="row">
            {showSidebar && !isMobile && (
              <div className="col-md-4 col-lg-3 sidebar">
                <div className="filters-card">
                  <div className="filters-card__header">
                    <span className="filters-title">Filters</span>
                    <button className="clear-link" onClick={() => this.clearFilters()}>Clear All</button>
                  </div>
                  <div className="filters-section">
                    <div className="price-range-heading">PRICE RANGE</div>
                    <InputRange
                      draggableTrack
                      maxValue={maxValue}
                      minValue={minValue}
                      step={1}
                      formatLabel={value => `$${value}`}
                      value={this.state.value}
                      onChange={this.updateRangeFilter}
                    />
                  </div>
                  <CollapsableItem title="VINTAGE" isCollapsed={isVintagePanintagePanelCollapsed} renderBody={this.renderVintage} onToggleBody={() => this.setState({
                    isVintagePanintagePanelCollapsed: !isVintagePanintagePanelCollapsed
                  })} />
                  <CollapsableItem title="TYPE" isCollapsed={isDescriptionPanelCollapsed} renderBody={this.renderDescriptions} onToggleBody={() => this.setState({
                    isDescriptionPanelCollapsed: !isDescriptionPanelCollapsed
                  })} />
                  <CollapsableItem title="COUNTRY" isCollapsed={isLocationPanelCollapsed} renderBody={this.renderLocations} onToggleBody={() => this.setState({
                    isLocationPanelCollapsed: !isLocationPanelCollapsed
                  })} />
                  <CollapsableItem title="SIZE" isCollapsed={isSizePanelCollapsed} renderBody={this.renderSizes} onToggleBody={() => this.setState({
                    isSizePanelCollapsed: !isSizePanelCollapsed
                  })} />

                </div>
              </div>
            )}
            <div className={showSidebar && !isMobile ? "col-md-8 col-lg-9" : "col-12"}>
              <div className="catalog-header">
                <div className="header-left">
                  <h1 className="page-title">{heading}</h1>
                  <div className="page-description">{`${products.length} products`}</div>
                </div>
                {!isMobile && (<div className="header-right">
                  
                    <button className="toolbar-button filter-button" onClick={() => this.toggleSidebar()}>
                      <i className="fa fa-sliders" aria-hidden="true" />
                      <span>Filters</span>
                    </button>
                  
                  <div className="sort-options-container">
                    <span>Sort By:</span>
                    <div className="select-wrap">
                      <select onChange={this.onChangeSortOption} defaultValue={sortBy} ref={(el) => this._sortBySelect = el}>
                        <option value="name_asc">{'Name: A to Z'}</option>
                        <option value="name_desc">{'Name: Z to A'}</option>
                        <option value="price_asc">{'Price: Low to High'}</option>
                        <option value="price_desc">{'Price: High to Low'}</option>
                      </select>
                    </div>
                  </div>
                  <div className="view-toggle">
                    <button
                      className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
                      aria-label="Grid view"
                      onClick={() => this.setState({ viewMode: 'grid' })}
                    >
                      <i className="fa fa-th-large" aria-hidden="true" />
                    </button>
                    <button
                      className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
                      aria-label="List view"
                      onClick={() => this.setState({ viewMode: 'list' })}
                    >
                      <i className="fa fa-bars" aria-hidden="true" />
                    </button>
                  </div>
                </div>)}
              </div>

              {this.renderAppliedFilters()}
              {this.renderCategoryTabs()}
              {this.renderSubCategories()}

              {isMobile ? (
                <div className="row product-cards-row-mobile">
                  {products && products.length > 0
                    ? products.map((product, idx) => (
                      <div className="col-6 product-cards-mobile" key={`product_mobile_${idx}`}>
                        <div className="product-card-container">
                          <ProductCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product)} noOutOfStock={true}/>
                        </div>
                      </div>
                    ))
                    : (
                      <div className="no-products-message">No products to show</div>
                    )
                  }
                </div>
              ) : (
                <div className={`row product-cards ${viewMode === 'list' ? 'list-view' : ''}`}>
                  {products && products.map((product, idx) => {
                    return (
                      <div className={`${viewMode === 'list' ? 'col-12 list' : 'col-md-6 col-lg-4'} product-card-container`} key={`product_${idx}`}>
                        <ProductCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product)} noOutOfStock={true}/>
                      </div>
                    )
                  })}
                </div>
              )}

              {this.renderLoadMoreButton()}

            </div>

          </div>
        </div>
        <div className="mobile-filter-sort-bar">
          <div className="filters-button button-block" onClick={() => {
            HtmlHelper.hideBodyScroll((scrollTop) => {
              this.setState({ SortFiltersModalVisibility: true, filterSortAction: 'filter', scrollTop: scrollTop });
            })
          }}>Filters</div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} onConfirm={() => this.setState({ showAlert: false })} />
        <SortFiltersModal visibility={SortFiltersModalVisibility} actionMode={filterSortAction} filters={filters} appliedFilters={appliedFilters} onApply={(filters, sort) => {
          this.setState({
            SortFiltersModalVisibility: false
          }, () => {
            this.onApplySortAndFilters(filters, sort);
            HtmlHelper.showBodyScroll(0);
          })
        }} onClose={() => {
          HtmlHelper.showBodyScroll(scrollTop);
          this.setState({ SortFiltersModalVisibility: false });
        }}
          onClearFilters={() => {
            HtmlHelper.showBodyScroll(0);
            this.setState({ SortFiltersModalVisibility: false }, () => this.clearFilters());
          }}
          hideSortOptions={true} />
      </div>
    )
  }

  renderDeliveryAddress() {
    return (
      <div className="filter-item-text">
        <ul>
          <li>828 s. Main Street,</li>
          <li>Los Angeles, CA 90014</li>
        </ul>
      </div>
    );
  }

  renderSizes() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_sizes
      ? filters.filterby_sizes.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_sizes.items.map((filter, idx) => {
                let isSelected = appliedFilters.filterby_sizes.indexOf(filter._id) != -1
                console.log("IS SELECTED", filter._id, appliedFilters.filterby_sizes.indexOf(filter._id));
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_sizes_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_sizes', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
        }
      </div>
    )
  }

  renderDescriptions() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_description
      ? filters.filterby_description.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_description.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_description.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_description_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_description', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
        }
      </div>
    )
  }
  rangeFilterUnselect(filter) {
    this.addValuesToFilter();
    this.selectFilter(filter.type, filter);
}

  renderAppliedFilters() {
    const { selectedFilters } = this.state;

    if (!selectedFilters.length) return null;

    return (
      <div className="applied-filters">
        {_.map(selectedFilters, (filter) => {
          if (filter.type === 'filterby_range') {
            let range = filter._id.split('-');
            return (
              <div className="filter-chip" key={filter._id}>
                {`$${range[0]} - $${range[1]}`}
                <button onClick={() => this.rangeFilterUnselect(filter)} aria-label="Remove filter">×</button>
              </div>
            );
          } else {
            return (
              <div className="filter-chip" key={filter._id}>
                {filter._id}
                <button onClick={() => this.selectedFilterUnselect(filter)} aria-label="Remove filter">×</button>
              </div>
            );
          }
        })}
        <button className="clear-link" onClick={() => this.clearFilters()}>Clear All</button>
      </div>
    );
  }

  renderCategoryTabs() {
    const { location, departments = [] } = this.props;
    const params = QueryString.parse(location.search);
    const pathname = location.pathname || '';
    const deptUpper = params.department ? params.department.toUpperCase() : '';
    const catUpper = params.category ? params.category.toUpperCase() : '';

    const findDepartmentLink = (matcher, fallback) => {
      const match = departments.find(dep => matcher(dep.dep.toUpperCase()));
      return match
        ? `/products?department=${encodeURIComponent(match.dep)}`
        : fallback;
    };

    const tabs = [
      { key: 'sparklingwine', label: 'SPARKLING WINE', dot: 'sparkling-wine', to: findDepartmentLink(dep => dep.includes('SPARKLING WINE'), `/products?department=${encodeURIComponent('SPARKLING WINE')}`) },
      { key: 'rosewine', label: 'ROSE WINE', dot: 'rose-wine', to: findDepartmentLink(dep => dep.includes('ROSE WINE'), `/products?department=${encodeURIComponent('ROSE WINE')}`) },
      { key: 'redwine', label: 'RED WINE', dot: 'red-wine', to: findDepartmentLink(dep => dep.includes('RED WINE'), `/products?department=${encodeURIComponent('RED WINE')}`) },
      { key: 'whitewine', label: 'WHITE WINE', dot: 'white-wine', to: findDepartmentLink(dep => dep.includes('WHITE WINE'), `/products?department=${encodeURIComponent('WHITE WINE')}`) },
      // { key: 'wine', label: 'WINE', dot: 'wine', to: findDepartmentLink(dep => dep.includes('WINE'), `/products?department=${encodeURIComponent('WINES')}`) },
      { key: 'liquor', label: 'LIQUOR', dot: 'liquor', to: findDepartmentLink(dep => dep === 'LIQUOR', `/products?department=${encodeURIComponent('LIQUOR')}`) },
      { key: 'beer', label: 'BEER', dot: 'beer', to: findDepartmentLink(dep => dep === 'BEER', `/products?department=${encodeURIComponent('BEER')}`) },
      { key: 'mixers', label: 'MIXERS & MORE', dot: 'mixers-supplies', to: findDepartmentLink(dep => dep.includes('MIXERS'), `/products?department=${encodeURIComponent('MIXERS & SUPPLIES')}`) },
      { key: 'pharmacy', label: 'PHARMACY & MORE', dot: 'pharmacy-more', to: findDepartmentLink(dep => dep.includes('PHARMACY'), `/products?department=${encodeURIComponent('PHARMACY & MORE')}`) },
      { key: 'tobacco', label: 'TOBACCO', dot: 'tobacco', to: findDepartmentLink(dep => dep === 'TOBACCO', `/products?department=${encodeURIComponent('TOBACCO')}`) },
      { key: 'snacks', label: 'SNACKS', dot: 'snacks', to: findDepartmentLink(dep => dep === 'SNACKS', `/products?department=${encodeURIComponent('SNACKS')}`) },
      { key: 'sale', label: 'SALE', dot: 'sale', to: '/products/specials' }
    ];

    const getActive = () => {
      if (pathname.includes('specials')) return 'sale';
      if (deptUpper.includes('SPARKLING WINE') || catUpper.includes('SPARKLING WINE')) return 'sparklingwine';
      if (deptUpper.includes('ROSE WINE') || catUpper.includes('ROSE WINE')) return 'rosewine';
      if (deptUpper.includes('RED WINE') || catUpper.includes('RED WINE')) return 'redwine';
      if (deptUpper.includes('WHITE WINE') || catUpper.includes('WHITE WINE')) return 'whitewine';
      if (deptUpper.includes('WINE') || catUpper.includes('WINE')) return 'wine';
      if (deptUpper === 'LIQUOR' || catUpper === 'LIQUOR') return 'liquor';
      if (deptUpper === 'BEER' || catUpper === 'BEER') return 'beer';
      if (deptUpper.includes('MIXERS')) return 'mixers';
      if (deptUpper.includes('PHARMACY') || catUpper.includes('PHARMACY')) return 'pharmacy';
      if (deptUpper === 'TOBACCO' || catUpper === 'TOBACCO') return 'tobacco';
      if (deptUpper === 'SNACKS' || catUpper === 'SNACKS') return 'snacks';
      return '';
    };

    const active = getActive();

    return (
      <div className="category-tabs-wrap">
        <div className="category-tabs">
          {tabs.map(tab => (
            <Link
              key={tab.key}
              to={tab.to}
              className={`category-tab ${active === tab.key ? 'active' : ''}`}
            >
              <span className={`pill-dot dep-${tab.dot}`} aria-hidden="true" />
              <span className="pill-label">{tab.label}</span>
            </Link>
          ))}
        </div>
      </div>
    );
  }

  renderSubCategories() {
    const { departments = [], location } = this.props;
    if (!departments.length) return null;

    const params = QueryString.parse(location.search);
    const pathname = location.pathname || '';
    if (pathname.includes('specials')) return null;
    const deptUpper = params.department ? params.department.toUpperCase() : '';
    const catUpper = params.category ? params.category.toUpperCase() : '';

    const menuSet = departments.reduce((acc, department) => {
      if (department && department.dep && department.cat && department.cat.length) {
        acc[department.dep] = department.cat;
      }
      return acc;
    }, {});

    const getActiveDepartments = () => {
      if (catUpper) {
        const match = departments.find(dep => dep.dep && dep.cat && dep.cat.some(cat => (cat || '').toUpperCase() === catUpper));
        return match ? [match.dep] : [];
      }
      if (deptUpper) {
        if (deptUpper === 'LIQUOR' || deptUpper === 'SPIRITS') return ['LIQUOR'];
        if (deptUpper === 'BEER') return ['BEER'];
        if (deptUpper.includes('MIXERS')) return departments.filter(dep => (dep.dep || '').toUpperCase().includes('MIXERS')).map(dep => dep.dep);
        if (deptUpper.includes('WINE')) return departments.filter(dep => (dep.dep || '').toUpperCase().includes('WINE')).map(dep => dep.dep);
        return [params.department];
      }
      return [];
    };

    const activeDepartments = getActiveDepartments();
    const subMenus = activeDepartments.length > 0
      ? activeDepartments.filter(dep => menuSet[dep])
      : Object.keys(menuSet);
    if (!subMenus.length) return null;

    return (
      <div className="category-submenus">
        <div className="row">
          {subMenus.map((menu, mid) => (
            <div className="col-md-3 category-submenu" key={`sub_category_${mid}`}>
              <div className="nav-title">{subMenus.length === 1 ? `ALL ${menu}` : menu}</div>
              <ul className="category-submenu-chips">
                {menuSet[menu].map((menuItem, miid) => (
                  <li key={`sub_category_item_${miid}`}>
                    <Link to={`/products?category=${encodeURIComponent(menuItem)}`}>
                      {Utils.toTitleCase(menuItem)}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="extra-link">
                <Link to={`/products?department=${encodeURIComponent(menu)}`}>View all</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderBreadcrumbs(title) {
    return (
      <div className="breadcrumbs">
        <Link to="/">Home</Link>
        <span className="crumb-separator">›</span>
        <span className="crumb-current">Shop</span>
        <span className="crumb-separator">›</span>
        <span className="crumb-current">{title || 'Specials'}</span>
      </div>
    );
  }

  renderAppliedFilters() {
    const { selectedFilters } = this.state;

    if (!selectedFilters.length) return null;

    return (
      <div className="applied-filters">
        {_.map(selectedFilters, (filter) => {
          if (filter.type === 'filterby_range') {
            let range = filter._id.split('-');
            return (
              <div className="filter-chip" key={filter._id}>
                {`$${range[0]} - $${range[1]}`}
                <button onClick={() => this.rangeFilterUnselect(filter)} aria-label="Remove filter">×</button>
              </div>
            );
          } else {
            return (
              <div className="filter-chip" key={filter._id}>
                {filter._id}
                <button onClick={() => this.selectedFilterUnselect(filter)} aria-label="Remove filter">×</button>
              </div>
            );
          }
        })}
        <button className="clear-link" onClick={() => this.clearFilters()}>Clear All</button>
      </div>
    );
  }

  addValuesToFilter() {
    let maxValue=0,
        minValue = 0,
        range = {...this.state.value};
    if(this.state.filters && this.state.filters.filterby_range && this.state.filters.filterby_range.items && 
      this.state.filters.filterby_range.items[0] && this.state.filters.filterby_range.items[0]){
        maxValue = Math.round(this.state.filters.filterby_range.items[0].priceMax);
        minValue = Math.floor(this.state.filters.filterby_range.items[0].priceMin);
      }
    range.min = minValue;
    range.max = maxValue;
      this.setState({
                  value: range, 
                  maxValue:maxValue,
                  minValue: minValue});
  } 

  renderLocations() {

    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_location
      ? filters.filterby_location.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_location.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_location.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_location_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_location', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
        }
      </div>
    )
  }

  renderVintage() {
    const { filters, appliedFilters } = this.state;
    let filterCount = filters && filters.filterby_vintage
      ? filters.filterby_vintage.items.length
      : 0;
    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_vintage.items.map((filter, idx) => {
                  let isSelected = appliedFilters.filterby_vintage && appliedFilters.filterby_vintage.indexOf(filter._id) != -1
                  return filter._id && filter._id.trim()
                    ? (
                      <li key={`filterby_vintage_${filter._id}`} className={`option ${isSelected
                        ? 'active'
                        : ''}`} onClick={() => this.selectFilter('filterby_vintage', filter)}>{`${filter._id} (${filter.count})`}</li>
                    )
                    : null
              })
              }
            </ul>
          )
          : null
        }
      </div>
    )
  }


  renderSelectedFilters() {
    return null;
  }

  rangeFilterUnselect(filter) {
    this.addValuesToFilter();
    this.selectFilter(filter.type, filter);
  }

  selectedFilterUnselect(filter) {
    console.log(filter);

    this.selectFilter(filter.type, filter);
    //
    // if(filter.type == 'size'){
    //   this.selectFilter('filterby_sizes', filter)
    // }else{
    //   this.selectFilter('filterby_description', filter)
    // }
  }

  selectFilter(type, filter) {

    const { products, skip, sortBy } = this.state;
    let modifiedFilters = this.state.appliedFilters;
    let selectedFilters = this.state.selectedFilters;
    console.log(filter);
    let modifiedFilter = Object.assign({}, filter);
    modifiedFilter['type'] = type;
    let indexOfFilter = selectedFilters.findIndex(x => x._id == filter._id);
    console.log("Selected FIlter Index", indexOfFilter);

    if(type === DEFAULT_FILTERS.filterby_range.id) {
      selectedFilters.forEach(function (value, index){
        if(value.type === type){
          selectedFilters.splice(index, 1);
        }
      })  
      modifiedFilters[type] = []; 
    }

    if (indexOfFilter < 0) {
      selectedFilters.push(modifiedFilter);
    } else {
      selectedFilters.splice(indexOfFilter, 1);
    }


    if (!modifiedFilters[type])
      modifiedFilters[type] = [];
    if (modifiedFilters[type].indexOf(filter._id) < 0) {
      modifiedFilters[type].push(filter._id);
    }
    else {
      modifiedFilters[type].splice(modifiedFilters[type].indexOf(filter._id), 1);
    }
    this.setState({ selectedFilters })
    this.onApplySortAndFilters(modifiedFilters, sortBy);
  }

  onApplySortAndFilters(filters, sortBy) {

    const { products, skip } = this.state;
    const nextSort = sortBy || this.state.sortBy;
    let isFilters = (filters.filterby_sizes.length > 0) || (filters.filterby_description.length > 0) || (filters.filterby_location.length > 0) || (filters.filterby_vintage > 0) || (filters.filterby_range.length > 0);
    this.setState({
      appliedFilters: filters,
      sortBy: nextSort,
      products: isFilters
        ? []
        : products,
      skip: isFilters
        ? 0
        : skip,
      isParamsChanged: true
    }, () => {
      this.loadProducts();
    });
  }

  clearFilters() {

    const { sortBy } = this.state;
    this.setState({
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: [],
        filterby_vintage: [],
        filterby_range: []
      },
      selectedFilters: [],
      sortBy: sortBy,
      products: [],
      skip: 0
    }, () => {
      this.loadProducts();
    });
    this.addValuesToFilter();
  }

  renderLoadMoreButton() {

    const { isLoadMore } = this.state;

    return isLoadMore
      ? (
        <div className="load-more-button" onClick={() => this.loadMore()}>Load More</div>
      )
      : null;
  }

  loadProducts(params, options) {

    const { location, match } = this.props;
    const { limit, products, isParamsChanged, appliedFilters, sortBy } = this.state;
    params = params
      ? params
      : QueryString.parse(location.search);
    let skip = options && options.skip
      ? options.skip
      : this.state.skip;
    if (isParamsChanged)
      skip = 0;

    params.limit = limit;
    params.skip = skip;
    params.filters = appliedFilters;
    params.sortOptions = buildSortByOptions(sortBy);
    const specialSale = match && match.params
      ? match.params.special
      : null;
    if (specialSale) {
      params.specialSale = specialSale;
    }
    this.props.dispatch(ProductsActions.getSpecialProducts(params, response => {
      console.log("GET_SPECIALS_RESPONSE", response);
      if (response.status) {
        this.setState({
          products: isParamsChanged
            ? response.data
            : products.concat(response.data),
          skip: skip,
          isLoadMore: response.data && (response.data.length == limit)
        });
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Something went wrong, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }

    }));
  }

  loadMore() {

    const { limit } = this.state;
    const { location } = this.props;
    let params = QueryString.parse(location.search);
    let skip = this.state.skip + limit;
    this.setState({
      isParamsChanged: false
    }, () => {
      this.loadProducts(params, { skip });
    })

  }

  loadFilters(params) {
    const {match} = this.props;
    const specialSale = match && match.params
      ? match.params.special
      : null;
    const data = {
      type: 'department',
      name: 'SPECIALS'
    };

    if (specialSale) {
      data.specialSale = specialSale;
    }

    this.props.dispatch(ProductsActions.getProductFilters(data, response => {
      console.log("FILTERS_GET_RESPONSE", response);
      if (response.status) {
        this.setState({ filters: response.data })
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Something went wrong, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }

    }))
  }

  updateRangeFilter(value) {
    this.setState({ value: value });
    const max = value.max;
    const min = value.min;
    this.selectFilter('filterby_range',{_id: `${min}-${max}`});
  }

  openFilters() {
    HtmlHelper.hideBodyScroll((scrollTop) => {
      this.setState({
        SortFiltersModalVisibility: true,
        filterSortAction: 'filter',
        scrollTop
      });
    });
  }

  toggleSidebar() {
    const { isMobile } = this.props;
    if (isMobile) {
      this.openFilters();
    } else {
      this.setState(prev => ({ showSidebar: !prev.showSidebar }));
    }
  }

  onChangeSortOption(e) {
    let selectedSortOption = e.target.value;

    this.setState({
      products: [],
      sortBy: selectedSortOption,
      skip: 0
    }, () => {
      this.loadProducts();
    });

    console.log("Selected sort option", selectedSortOption);
  }


  exploreProduct(product) {

    const { location } = this.props;
    console.log("PRODUCT_SELECTED_ID: ", product._id);

    let state = this.state;
    state.location = location;
    state.scrollTop = window.pageYOffset;
    this.props.dispatch(ProductsActions.setListPageState(fromJS(state)));
    this.props.history.push(`/products/${product._id}`);
  }

  addToCart(product) {
    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false,
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        console.error(err);
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
      });
  }

}

function buildSortByOptions(selectedSortOption) {

  let sortOption = {};
  switch (selectedSortOption) {

    case 'name_asc':
    default:
      sortOption.Description = 1
      break;
    case 'name_desc':
      sortOption.Description = -1
      break;
    case 'price_asc':
      sortOption.PriceB = 1
      break;
    case 'price_desc':
      sortOption.PriceB = -1
  }
  return sortOption;
}

const DEFAULT_FILTERS = {
  filterby_sizes: {
    id: 'filterby_sizes',
    name: 'Sizes',
    index: 'Size',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_description: {
    id: 'filterby_description',
    name: 'Descriptions',
    index: 'Sub Description 2',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_location: {
    id: 'filterby_location',
    name: 'Locations',
    index: 'Sub Description 3',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_vintage: {
    id: 'filterby_vintage',
    name: 'Vintage',
    index: 'Vintage',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_range: {
    id: 'filterby_range',
    name: 'Range',
    index: 'PriceB',
    itemType: 'Range',
    items: [],
    products: {}
  }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 768,
    isTablet: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    pageState: state.getIn(['products', 'listPageState']),
    loading: state.getIn(['products', 'loading']),
    products: state.getIn(['products', 'products']),
    departments: state.getIn(['products', 'departments']) || []
  };
})(ProductListPage))



// WEBPACK FOOTER //
// ./src/containers/products/SpecialsListPage.js